import React from 'react'
import Navbar from '../components/header/navbar'
import Contacts from '../components/ContactUs/Contacts'
const Contact = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <Navbar />
      <Contacts />
    </div>
  )
}

export default Contact
